/**
 * @module cercaliagl/BaseObject
 */

import EventEmitter from 'eventemitter3';

/**
 * @classdesc
 * Abstract class for internal purposes. It can be extended to have `get()` and `set()` methods for objects for its subclasses
 */
class BaseObject extends EventEmitter {
  /**
   * @constructor
   */
  constructor() {
    super();
    /**
     * @private
     * @type {!Object<string, *>}
     */
    this.values_ = {};
  }

  /**
   * Gets a value.
   * @param {string} key Key name.
   * @return {*} Value.
   * @api
   */
  get(key) {
    let value;
    if (Object.prototype.hasOwnProperty.call(this.values_, key)) {
      value = this.values_[key];
    }
    return value;
  }

  /**
   * Sets a value.
   * @param {string} key Key name.
   * @param {*} value Value.
   * @param {boolean} [silent] Update without triggering an event.
   * @api
   */
  set(key, value) {
    this.values_[key] = value;
  }
}

export default BaseObject;
